"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discardNegativeDuration = discardNegativeDuration;
const browser_core_1 = require("@datadog/browser-core");
function discardNegativeDuration(duration) {
    return (0, browser_core_1.isNumber)(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=discardNegativeDuration.js.map